<template>
  <div>
    <wc-section-title title='Accounting'>
      <template v-slot:rightSide>
        <invoice-lookup-menu></invoice-lookup-menu>
      </template>
    </wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import InvoiceLookupMenu from '../components/InvoiceLookupMenu'

export default {
  name: 'accounting-base',
  computed: {
    menu () {
      return [
        {
          title: 'Accounting Dashboard',
          icon: this.$store.state.icons.modules.accounting.icon,
          route: { name: 'AccountingDashboard' }
        },
        {
          title: 'Reports',
          icon: 'mdi-chart-box-outline',
          subRoutesMenu:
          [
            {
              title: 'Receivables',
              icon: 'mdi-alert-circle-outline',
              color: 'warning',
              route: { name: 'UnpaidInvoicesReport' }
            },
            {
              title: 'Unsent',
              icon: 'mdi-alert-circle-outline',
              color: 'info',
              route: { name: 'UnsentInvoicesReport' }
            },
            {
              title: 'Archived Invoices',
              icon: 'mdi-archive',
              color: 'error',
              route: { name: 'ArchivedInvoicesReport' }
            },
            {
              title: 'UN-Collectible Invoices',
              icon: 'mdi-alert-octagon-outline',
              color: 'warning',
              route: { name: 'UncollectibleInvoicesReport' }
            },
          ]
        },
        {
          title: 'Receive Payments',
          icon: 'mdi-receipt',
          route: { name: 'ReceivePayments' }
        },
        {
          title: 'Record Expenses',
          icon: this.$store.state.icons.dataBox.expenses.icon,
          route: { name: 'PostExpenses' }
        },
        {
          title: 'Credit Card Processing',
          icon: this.$store.state.icons.dataBox.creditCards.icon,
          route: { name: 'CreditCardProcessing' }
        },
        {
          title: 'Reconciliations',
          icon: this.$store.state.icons.dataBox.bankRecs.icon,
          subRoutesMenu: [
            {
              title: 'Account Reconciliations',
              icon: this.$store.state.icons.dataBox.bankRecs.icon,
              route: { name: 'AllReconciliations' }
            },
            {
              title: 'Legacy Statements',
              icon: 'mdi-check-all',
              route: { name: 'AllStatements' }
            },
          ]
        },
        {
          title: this.$store.state.icons.dataBox.deposits.title,
          icon: this.$store.state.icons.dataBox.deposits.icon,
          route: { name: 'ChequeDeposits' }
        },
        {
          title: this.$store.state.icons.dataBox.accounts.title,
          icon: this.$store.state.icons.dataBox.accounts.icon,
          route: { name: 'Accounts' }
        },
        {
          title: 'Invoice PDF Designer',
          icon: 'mdi-file-edit-outline',
          route: { name: 'InvoiceTemplateDesigner' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Accounting Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  },
  components: {
    'invoice-lookup-menu': InvoiceLookupMenu
  }
}
</script>
